import script from "./PivotTableWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./PivotTableWidget.vue?vue&type=script&setup=true&lang=js"

import "./PivotTableWidget.vue?vue&type=style&index=0&id=6d8c6e88&scoped=true&lang=css"

import exportComponent from "../../../SherpaCRM/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d8c6e88"]])

export default __exports__